import { TbMailForward, TbMailOff } from "react-icons/tb";
import { BiPrinter } from "react-icons/bi";
import { FaCircle } from "react-icons/fa";
import { RxDotFilled } from "react-icons/rx"; 
import { BiLockOpenAlt } from "react-icons/bi"; 
import { BiLockAlt } from "react-icons/bi"; 
import { BiDotsVerticalRounded, } from "react-icons/bi";
import React from 'react';
import { useTranslation } from '../../hx/useTranslation';
import * as FxLog from '../../fx/FxLog';
import { useNav } from '../../hx/useNav';
import CxTable from '../../cx/CxTable';
import CxButtonMenu from '../../cx/CxButtonMenu';
import CxIconButtonMenu from '../../cx/CxIconButtonMenu';
import CxIconButtonNew from '../../cx/CxIconButtonNew';
import CxDlgRadioList from '../../cx/CxDlgRadioList';
import CxChooser from '../../cx/CxChooser';
import CxDate from '../../cx/CxDate';
import CxTooltip from '../../cx/CxTooltip';
import * as FxTable from '../../fx/FxTable';
import * as FxEdition from '../../fx/FxEdition';
import * as FxFetch from '../../fx/FxFetch';
import * as FxGeneral from '../../fx/FxGeneral';
import * as FxStr from '../../fx/FxStr';
import DocType from '@material-ui/icons/Receipt';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { useWindowSize } from '../../hx/useWindowSize';
import { getStoreValue, getStoreValueBo, clearStore, StoreSlsLst, StoreSlsDoc, StoreCyStats, StoreLongTask } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import * as MxSlsDocFormH1 from './MxSlsDocFormH1';
import CxToolbar from '../../cx/CxToolbar';
import CxDialog from '../../cx/CxDialog';
import { makeStyles } from '@material-ui/core/styles';
import MxSlsDocListQuickPaymDlg from './MxSlsDocListQuickPaymDlg';
import CxSnackbar from '../../cx/CxSnackbar';
import { isApp } from '../../gx/GxStore';
import GxIconButtonLastClient from '../../gx/GxIconButtonLastClient';
import GxPrint from '../../gx/GxPrint';
import GxEmail from '../../gx/GxEmail';
import { useLocation } from 'react-router-dom';
import { ReactComponent as VerifactuSVG } from '../../../assets/img/svg/verifactu.svg';
import CxIcon from '../../cx/CxIcon';
import { useAccess } from '../../hx/useAccess';

const useStyles = makeStyles({
  toggleButtonGroup: {
    background: 'var(--ibs_color_gray_light)',
    '& .MuiToggleButton-root.Mui-selected': {
      background: 'var(--ibs_color_white)',
    },
    '& .MuiToggleButton-root': {
      padding: '0px 10px 0px 10px',
    },
  },
});

const MxSlsDocList = (props) => {
  const [{ trans }] = useTranslation();
  const classes = useStyles();
  const [{ navTo }] = useNav();
  const size = useWindowSize();
  const { state } = useLocation(); //captura los parámetros de navBack()

  // Usamos la función 'access' para consultar el nivel exacto de cada uno
  const [{ access }] = useAccess();
  const strAccessQ = access(trans('field.sls_quo')); // Devolverá 'W', 'R', 'N'
  const strAccessI = access(trans('field.sls_inv')); // Devolverá 'W', 'R', 'N'
  const strAccessR = access(trans('field.sls_rec')); // Devolverá 'W', 'R', 'N'

  const [isMasterUser, ] = React.useState(getStoreValue('StoreSession', 'txUser')==='master');

  const [useInvoices,] = React.useState(getStoreValueBo('StoreSession', 'boUseInvoices'));
  const [useReceipts,] = React.useState(getStoreValueBo('StoreSession', 'boUseReceipts'));
  const [isVerifactu,] = React.useState(getStoreValue('StoreSession', 'txERec')==='VF');

  const hasColumnBranchId = () => { return Boolean(localStorage.getItem('MxSlsDocList.addcol_txBranchId') === '1') };
  const hasColumnSeries = () => { return Boolean(localStorage.getItem('MxSlsDocList.addcol_txTypeSeries') === '1') };
  const hasColumnReference = () => { return Boolean(localStorage.getItem('MxSlsDocList.addcol_txReference') === '1') };
  const hasColumnTypePayment = () => { return Boolean(localStorage.getItem('MxSlsDocList.addcol_txTypePayment') === '1') };

  const [, updateState] = React.useState();
  const forceUIUpdate = React.useCallback(() => updateState({}), []);

  const rf_table = React.useRef(null);
  const [lockOps, setLockedOps] = React.useState(true);
  const [lockSend, setLockSend] = React.useState(true);

  const [dlgAskSureToClone, setDlgAskSureToClone] = React.useState(false);
  const [inXXXToClone, setInXXXToClone] = React.useState(false);
  
  let r_print = React.useRef(null);
  let r_email_direct = React.useRef(null);

  let r_snack_op_successful = React.useRef(null);
  let r_snack_error = React.useRef(null);
  let r_snack_required = React.useRef(null);
  let r_dlg_quick_paym = React.useRef(null);

  let r_dlg_special_options = React.useRef(null);
  let r_dlg_special_options_ask_from_n_series = React.useRef(null);
  let rf_special_options_from = React.useRef(null);
  let rf_special_options_series = React.useRef(null);
  const [dlgSpecialOptionsAskFromAndSeries, setDlgSpecialOptionsAskFromAndSeries] = React.useState(false);

  const [storeSlsLst, setStoreSlsLst] = useSessionStorage('StoreSlsLst', StoreSlsLst);
  const [storeSlsDoc, setStoreSlsDoc] = useSessionStorage('StoreSlsDoc', StoreSlsDoc);
  const [storeLongTask, setStoreLongTask] = useSessionStorage('StoreLongTask', StoreLongTask);
  // eslint-disable-next-line
  const [storeCyStats, setStoreCyStats] = useSessionStorage('StoreCyStats', StoreCyStats);

  const [docTitle, setDocTitle] = React.useState(trans('field.invoices'));

  const getValidListType = () => {
    let cached = storeSlsLst.listType;
    
    // Primero validamos si el guardado en cache es válido según accesos actuales
    if (cached === 'i' && useInvoices && strAccessI !== 'N') return 'i';
    if (cached === 'q' && strAccessQ !== 'N') return 'q';
    if (cached === 'r' && useReceipts && strAccessR !== 'N') return 'r';

    // Si no hay cache válido, resolvemos en cascada según prioridad
    if (useInvoices && strAccessI !== 'N') return 'i';
    if (strAccessQ !== 'N') return 'q';
    if (useReceipts && strAccessR !== 'N') return 'r';

    return null; // Sin acceso a nada
  }

  const validListType = getValidListType();

  React.useEffect(() => {
    FxLog.infox('MxSlsDocList.useEffect', '...', storeSlsLst);
    if (validListType && validListType !== storeSlsLst.listType) {
      storeSlsLst.listType = validListType;
      setStoreSlsLst(storeSlsLst);
    }
    changeDocType(null, validListType);
    clearStore('StoreLongTask', storeLongTask);

    // eslint-disable-next-line
  }, []);

  const onReady = () => {
    if (state) {
      FxLog.infox('MxSlsDocList.useEffect', '...state:', state);
      if (state.txAnimal) {
        rf_table.current.setSearchForced(`${state.txClient}+${state.txAnimal}`);
        return;
      }
      if (state.txClient) {
        rf_table.current.setSearchForced(state.txClient);
        return;
      }
    }
  }

  const showSpecialOptions = async () => {
    const canUpdateDelete = await FxGeneral.getCanUpdateDelete();
    if (canUpdateDelete === null) {
      r_snack_error.current.setValAndOpen(trans('msg.connection_refused'));
    } else if (canUpdateDelete && !isVerifactu) {
      r_dlg_special_options.current.setOpenAndFill(true);
    } else {
      r_snack_error.current.setValAndOpen(trans('msg.operation_not_allowed'));
    }
  }

  const doSpecialOption = (option) => {
    storeLongTask._url = 'sls/doclist/special_options';
    let record = { 
      searchText: rf_table.current.getSearchText(), 
      tooltip: rf_table.current.getTooltipText(), 
      dateFrom: rf_table.current.getOptionalFrom(), 
      dateTo: rf_table.current.getOptionalTo(), 
    };
    storeLongTask._canCancel = true;
    switch (option) {
      case "delete":
        if (storeSlsLst.listType === 'r') {
          storeLongTask._record = { txTaskName: "delete_listed_receipts", ...record };
          storeLongTask._warning = trans('msg.delete_warning_x_0', 'field.receipts');
        }
        if (storeSlsLst.listType === 'i') {
          storeLongTask._record = { txTaskName: "delete_listed_invoices", ...record };
          storeLongTask._warning = trans('msg.delete_warning_x_1', 'field.invoices');
        }
        if (storeSlsLst.listType === 'q') {
          storeLongTask._record = { txTaskName: "delete_listed_quotations", ...record };
          storeLongTask._warning = trans('msg.delete_warning_x_1', 'field.quotations');
        }
        break;
      case "renum":
        if (storeSlsLst.listType === 'r') {
          storeLongTask._record = { txTaskName: "renum_listed_receipts", ...record };
          storeLongTask._warning = trans('msg.renum_warning_x_0', 'field.receipts');
        }
        if (storeSlsLst.listType === 'i') {
          storeLongTask._record = { txTaskName: "renum_listed_invoices", ...record };
          storeLongTask._warning = trans('msg.renum_warning_x_1', 'field.invoices');
        }
        if (storeSlsLst.listType === 'q') {
          storeLongTask._record = { txTaskName: "renum_listed_quotations", ...record };
          storeLongTask._warning = trans('msg.renum_warning_x_1', 'field.quotations');
        }
        break;
      default: break;
    }
    Promise.all([setStoreLongTask(storeLongTask)]).then((result) => {
      if (option === 'delete') {
        navTo('sls-doc-list-spec-opt');
      }
      if (option === 'renum') {
        setDlgSpecialOptionsAskFromAndSeries(true);
      }
    });
  }

  const doSpecialOptionRenum = () => {
    if (rf_special_options_from.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_special_options_from.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }
    let dtFrom = rf_special_options_from.current.getVal();
    let itSeries = rf_special_options_series.current.getKey();
    storeLongTask._record = { ...storeLongTask._record, dtFrom: dtFrom, itSeries: itSeries };
    Promise.all([setStoreLongTask(storeLongTask)]).then((result) => {
      navTo('sls-doc-list-spec-opt');
    });
  }

  const openForm = async (op, row) => {
    FxLog.infox('MxSlsDocList.openForm', '...op:', op);
    storeSlsDoc.boFirstRender = true;
    storeSlsDoc.boDataChanged = '0';
    storeSlsDoc.docType = storeSlsLst.listType;
    if (row === null) {
      storeSlsDoc.inXXX = null;
      // 2025-11-28 - daq: si viene desde la ficha del cliente o paciente, al crear un nuevo albarán se preselecciona el cliente y paciente.
      let strSearchText = rf_table.current.getSearchText();
      if (state && (strSearchText===`${state.txClient}+${state.txAnimal}` || strSearchText===`${state.txClient}`)) {
        if (state.txAnimal) {
          storeSlsDoc.inAnimal = state.inAnimal;
          storeSlsDoc.txAnimal = state.txAnimal;
          storeSlsDoc.inClient = state.inClient;
          storeSlsDoc.txClient = state.txClient;
        } else {
          if (state.txClient) {
            storeSlsDoc.inClient = state.inClient;
            storeSlsDoc.txClient = state.txClient;
          }
        }
      }
      setStoreSlsDoc(storeSlsDoc);
      navTo("sls-doc-form");
      
    } else {
      storeSlsDoc.inXXX = row.original[storeSlsLst.table_idField];
      let canUpdateDelete = false;
      if (row.ctrlKey) {
        canUpdateDelete = await FxGeneral.getCanUpdateDelete();
        if (canUpdateDelete === null) {
          r_snack_error.current.setValAndOpen(trans('msg.connection_refused'));
          canUpdateDelete = false;
        }
      }
      storeSlsDoc.boUpdateDelete = row.ctrlKey && canUpdateDelete;
      FxLog.infox('MxSlsDocList.openForm', '...storeSlsDoc.boUpdateDelete:', storeSlsDoc.boUpdateDelete.toString());

      if (storeSlsDoc.boUpdateDelete && isVerifactu) {
        storeSlsDoc.boUpdateDelete = false;
        r_snack_error.current.setValAndOpen(trans('msg.operation_not_allowed'));
      } else {
        Promise.all([MxSlsDocFormH1.load(storeSlsLst, storeSlsDoc)]).then((result) => {
          setStoreSlsDoc(storeSlsDoc);
          navTo("sls-doc-form");
        });
      }
    }
  }

  const changeDocType = (event, newType) => {
    clearStore('StoreSlsDoc', storeSlsDoc);
    if (newType === null) {
      return;
    }
    let hasTypeChanged = false;
    if (newType !== storeSlsLst.listType) {
      hasTypeChanged = true;
    }
    switch (newType) {
      case 'q':
        storeSlsLst.listType = 'q';
        storeSlsLst.listTypeBackground = 'var(--ibs_color_yellow_light)';
        storeSlsLst.table = 'n_quotation';
        storeSlsLst.table_idField = 'inQuotation';
        storeSlsLst.table_txField = 'txQuotation';
        storeSlsLst.table_dtField = 'dtQuotation';
        storeSlsLst.table_item = 'n_quotation_item';
        storeSlsLst.table_item_idField = 'inQuotationItem';
        storeSlsLst.table_paym_idField = 'inPayment';
        Promise.all([setStoreSlsLst(storeSlsLst)]).then((result) => {
          setDocTitle(trans('field.quotations'));
          if (rf_table.current) {
            rf_table.current.setTableID(`MxSlsDocList-${storeSlsLst.listType}`);
            rf_table.current.setTooltipText(getTooltip());
            rf_table.current.setRefColors(getRefColors());
            if (hasTypeChanged) rf_table.current.redisplay('sls/doclist/q');
          }
        });
        break;
      case 'i':
        storeSlsLst.listType = 'i';
        storeSlsLst.listTypeBackground = 'var(--ibs_color_blue_light)';
        storeSlsLst.table = 'n_invoice';
        storeSlsLst.table_idField = 'inInvoice';
        storeSlsLst.table_txField = 'txInvoice';
        storeSlsLst.table_dtField = 'dtInvoice';
        storeSlsLst.table_item = 'n_invoice_item';
        storeSlsLst.table_item_idField = 'inInvoiceItem';
        storeSlsLst.table_paym_idField = 'inPayment';
        Promise.all([setStoreSlsLst(storeSlsLst)]).then((result) => {
          setDocTitle(trans('field.invoices'));
          if (rf_table.current) {
            rf_table.current.setTableID(`MxSlsDocList-${storeSlsLst.listType}`);
            rf_table.current.setTooltipText(getTooltip());
            rf_table.current.setRefColors(getRefColors());
            if (hasTypeChanged) rf_table.current.redisplay('sls/doclist/i');
          }
        });
        break;
      case 'r':
        storeSlsLst.listType = 'r';
        storeSlsLst.listTypeBackground = 'var(--ibs_color_green_light)';
        storeSlsLst.table = 'n_receipt';
        storeSlsLst.table_idField = 'inReceipt';
        storeSlsLst.table_txField = 'txReceipt';
        storeSlsLst.table_dtField = 'dtReceipt';
        storeSlsLst.table_item = 'n_invoice_item';
        storeSlsLst.table_item_idField = 'inInvoiceItem';
        storeSlsLst.table_paym_idField = 'inPayment';
        Promise.all([setStoreSlsLst(storeSlsLst)]).then((result) => {
          setDocTitle(trans('field.receipts'));
          if (rf_table.current) {
            rf_table.current.setTableID(`MxSlsDocList-${storeSlsLst.listType}`);
            rf_table.current.setTooltipText(getTooltip());
            rf_table.current.setRefColors(getRefColors());
            if (hasTypeChanged) rf_table.current.redisplay('sls/doclist/r');
          }
        });
        break;

      default:
        FxLog.errorx("MxSlsDocList.openForm", "Cannot find doctype!!! -> " + newType);
        break;
    }
  };

  const doLineOptions = (option, row) => {
    if (!option) {
      return;
    }
    try {

      // Marca presupuesto como aceptado o pendiente
      if (option === 'QA') {
        let record = {};
        record['inQuotation'] = row.inQuotation;
        Promise.all([FxFetch.doJsonX('sls/doclist/q/change_status', record)]).then((result) => {
          if (result[0]) {
            if (result[0].theValue === 'OK') {
              rf_table.current.refresh();
            }
          }
        });
      }

      // pago rápido albarán
      if (option === 'IP') {
        Promise.all([r_dlg_quick_paym.current.setRow(row), r_dlg_quick_paym.current.setListType(storeSlsLst.listType)]).then((result) => {
          let record = {};
          record['inClient'] = row.inClient;
          Promise.all([FxFetch.doJsonX('sls/doclist/get_client_debt', record)]).then((result) => {
            if (result[0]) {
              if (result[0].theValue) {
                r_dlg_quick_paym.current.setClientName(row.txClient);
                r_dlg_quick_paym.current.setAmountAll(result[0].theValue);
                r_dlg_quick_paym.current.setAmountOne(row.nuTotalFinal - row.nuTotalPayment || '0');
                r_dlg_quick_paym.current.setTableToRefresh(rf_table);
                r_dlg_quick_paym.current.setDlg(true);
              }
            }
          });
        });
      }

      // pago rápido factura
      if (option === 'RP') {
        Promise.all([r_dlg_quick_paym.current.setRow(row), r_dlg_quick_paym.current.setListType(storeSlsLst.listType)]).then((result) => {
          let record = {};
          record['inClient'] = row.inClient;
          Promise.all([FxFetch.doJsonX('sls/doclist/get_client_debt', record)]).then((result) => {
            if (result[0]) {
              if (result[0].theValue) {
                r_dlg_quick_paym.current.setClientName(row.txClient);
                r_dlg_quick_paym.current.setAmountAll(result[0].theValue);
                r_dlg_quick_paym.current.setAmountOne(row.nuTotalFinal - row.nuTotalPayment || '0');
                r_dlg_quick_paym.current.setTableToRefresh(rf_table);
                r_dlg_quick_paym.current.setDlg(true);
              }
            }
          });
        });
      }

      // clona albarán
      if (option === 'IC') {
        Promise.all([setInXXXToClone(row.inInvoice)]).then((result) => {
          setDlgAskSureToClone(true);
        });
      }

      // clona albaranes de factura
      if (option === 'RC') {
        Promise.all([setInXXXToClone(row.inReceipt)]).then((result) => {
          setDlgAskSureToClone(true);
        });
      }

    } catch (error) {
      FxLog.errorx("MxSlsDocList.doLineOptions", error);
    }
  }

  const doClone = () => {
    try {
      if (storeSlsLst.listType === 'i') {
        // clona albarán
        let record = {};
        record['inInvoice'] = inXXXToClone;
        record['boNegative'] = '0';
        Promise.all([FxFetch.doJsonX('sls/doclist/i/clone', record)]).then((result) => {
          FxLog.infox('MxSlsDocList.doClone', '...invoice result[0]:', result[0]);
          if (result[0]) {
            if (result[0].theValue === 'OK') {
              rf_table.current.redisplay();
            }
          }
        });
      }

      if (storeSlsLst.listType === 'r') {
        // clona albaranes de factura
        let record = {};
        record['inReceipt'] = inXXXToClone;
        record['boNegative'] = '0';
        Promise.all([FxFetch.doJsonX('sls/doclist/r/clone_invoices', record)]).then((result) => {
          FxLog.infox('MxSlsDocList.doClone', '...receipt result[0]:', result[0]);
          if (result[0]) {
            if (result[0].theValue) {
              FxLog.infox('MxSlsDocList.doClone', 'changing doc type...');
              changeDocType(null, 'i');
            }
          }
        });
      }

    } catch (error) {
      FxLog.errorx("MxSlsDocList.doClone", error);
    }
  }

  const doPrintX = async (option, row) => {
    let boPreview = false;
    let filter = {};
    filter['reportFormat'] = `PDF`;
    filter['inClient'] = row.inClient;
    filter['inXXX'] = FxStr.choose(storeSlsLst.listType, 'q|i|r', row.inQuotation, row.inInvoice, row.inReceipt);
    filter['docType'] = storeSlsLst.listType;
    filter['docSize'] = option;
    filter['nuCopies'] = '0';
    filter['salesSlipWidth'] = localStorage.getItem('MxSettSlsPrinting.sales_slip_width') || '60';
    filter['salesSlipMarginLeft'] = localStorage.getItem('MxSettSlsPrinting.sales_slip_margin_left') || '0';
    let record = {};
    if (filter['docSize'] === 'A8') {
      r_print.current.setScale(2.0);
    }
    if (filter['docSize'] === 'A4') {
      r_print.current.setScale(1.5);
    }
    r_print.current.setUrl('slsDoc/report');
    r_print.current.setPreview(boPreview);
    //----------------
    Promise.all([
      r_print.current.setFilter(filter),
      r_print.current.setRecord(record),
      r_print.current.setInClient(row.inClient),
    ]).then((result) => {
      r_print.current.doPrint();
    });
  }

  const getTableButtonMenu = (row) => {
    let rvButton;
    let theOptions;
    try {
      switch (storeSlsLst.listType) {
        case 'q':
          theOptions = [
            { id: 'QA', text: row.boAccepted === '1' ? trans('field.pending') : trans('field.accepted') },
          ];
          break;

        case 'i':
          theOptions = [
            { id: 'IP', text: trans('field.quick_x_1', 'field.payment') },
            { id: 'IC', text: trans('field.clone') },
          ];
          break;

        case 'r':
          theOptions = [
            { id: 'RP', text: trans('field.quick_x_1', 'field.payment') },
            { id: 'RC', text: trans('field.clone') + ' ' + trans('field.invoices') },
          ];
          break;

        default:
          break;
      }
      rvButton = <CxButtonMenu
        row={row}
        onSelection={doLineOptions}
        className='ibs_iconbutton_table'
        icon={<BiDotsVerticalRounded />}
        options={theOptions}
        disabled={lockOps}
      />

    } catch (error) {
      FxLog.errorx("MxSlsDocList.getTableButtonMenu", error);
    }
    return rvButton;
  };

  const getRefColors = () => {
    let rv;
    try {
      switch (storeSlsLst.listType) {
        case 'q':
          rv = ['table_cell_color_green|' + trans('field.accepted')];
          break;

        case 'i':
          if (useReceipts) {
            rv = ['table_cell_color_red|' + trans('field.debtor'), 'table_cell_color_blue|' + trans('field.voided_1'), 'table_cell_color_green|' + trans('field.receipted')];
          } else {
            rv = ['table_cell_color_red|' + trans('field.debtor')];
          }
          break;

        case 'r':
          if (useReceipts) {
            rv = ['table_cell_color_red|' + trans('field.debtor'), 'table_cell_color_blue|' + trans('field.voided_0')];
          } else {
            rv = ['table_cell_color_red|' + trans('field.debtor')];
          }
          if (isVerifactu) {
            rv.push(`table_cell_color_gray|Verifactu - En proceso`);
            rv.push(`table_cell_color_brown|Verifactu - Rechazada`);
            //rv.push(`table_cell_color_green|Verifactu - Aceptada`);
          }
          break;

        default: break;
      }

    } catch (error) {
      FxLog.errorx("MxSlsDocList.getrefColors", error);
    }
    return rv;
  }

  const getTableColumns = () => {
    let cols = [];
    let id = -1;
    cols.push({ id: id++, Header: "ID", accessor: storeSlsLst.table_idField, show: false });
    cols.push({ id: 'xx1', Header: "_itSeries", accessor: "itSeries", show: false }); // 2023-05-13 - daq: ATENCIÓN: con id numérico no la oculta.
    cols.push({ id: 'xx2', Header: "_inClient", accessor: "inClient", show: false }); // 2023-05-13 - daq: ATENCIÓN: con id numérico no la oculta.
    cols.push({ id: 'txEmail', Header: "_txEmail", accessor: "txEmail", show: false }); 
    if (size.isLarge) { // PANTALLA GRANDE
      cols.push({ id: "xx3", Header: trans('field.branch_id'), accessor: row => rf_table.current.highlightText(row["txBranchId"]), width: '5%', show: hasColumnBranchId() });
      cols.push({ id: "xx4", Header: trans('field.series'), accessor: row => rf_table.current.highlightText(row["txTypeSeries"]), width: '10%', show: hasColumnSeries() });
      cols.push({ id: id++, Header: trans('field.doc'), accessor: row => rf_table.current.highlightText(row[storeSlsLst.table_txField]), width: '12%' });
      cols.push({ id: id++, Header: trans('field.date'), accessor: row => rf_table.current.highlightDate(row[storeSlsLst.table_dtField]), width: '10%' });
      cols.push({ id: id++, Header: trans('field.client'), accessor: row => rf_table.current.highlightText(row["txClient"]), width: '28%' });
      if ((isApp('vett') || isApp('spaw'))) {
        storeSlsLst.listType !== 'r' && cols.push({ id: id++, Header: trans('field.patient'), accessor: row => rf_table.current.highlightText(row["animal_txAnimal"]), width: '15%' });
      }
      cols.push({ id: id++, Header: trans('field.reference'), accessor: row => rf_table.current.highlightText(row["txReference"]), width: '15%', show: hasColumnReference() });
      cols.push({ id: id++, Header: trans('field.taxable'), accessor: row => (FxTable.cellTo2r00(row["nuTotalTaxable"])), width: '10%', align: 'right' });
      cols.push({ id: id++, Header: trans('field.discount'), accessor: row => (FxTable.cellTo2r00(row["nuTotalDiscount"])), width: '10%', align: 'right' });
      cols.push({ id: id++, Header: trans('field.tax'), accessor: row => (FxTable.cellTo2r00(row["nuTotalTax"])), width: '10%', align: 'right' });
      cols.push({ id: id++, Header: trans('field.wtax_perc'), accessor: row => (FxTable.cellTo2r00(row["nuTotalWtaxPerc"])), show: false });
      cols.push({ id: id++, Header: trans('field.total'), accessor: row => (FxTable.cellTo2r00(row["nuTotalFinal"])), width: '10%', align: 'right' });
      cols.push({ id: id++, Header: trans('field.accepted'), accessor: row => (FxTable.cellToYesNo(row["boAccepted"])), width: '10%', align: 'right', show: (storeSlsLst.listType === 'q') });
      cols.push({ id: id++, Header: trans('field.paid'), accessor: row => (FxTable.cellTo2r00(row["nuTotalPayment"])), width: '10%', align: 'right', show: (storeSlsLst.listType !== 'q') });
      cols.push({ id: id++, Header: trans('field.type_payment'), accessor: row => row["txTypePayment"], width: '10%', align: 'left', show: (storeSlsLst.listType !== 'q' && hasColumnTypePayment()) });
  
    } else { // PANTALLA PEQUEÑA
      cols.push({ id: id++, Header: trans('field.date'), accessor: row => rf_table.current.highlightDate(row[storeSlsLst.table_dtField]), width: '30%' });
      cols.push({ id: id++, Header: trans('field.client'), accessor: row => rf_table.current.highlightText(row["txClient"]), width: '50%' });
      cols.push({ id: id++, Header: trans('field.wtax_perc'), accessor: row => (FxTable.cellTo2r00(row["nuTotalWtaxPerc"])), show: false });
      cols.push({ id: id++, Header: trans('field.total'), accessor: row => (FxTable.cellTo2r00(row["nuTotalFinal"])), width: '20%', align: 'right' });
    }
    cols.push({
      id: "BTN_OPT",
      icon: <BiLockAlt style={{marginTop:'-1px'}} />, icon_alt: <BiLockOpenAlt style={{marginTop:'-1px'}} />, iconTooltip: trans('field.column_lock_unlock'), onIconClick: () => setLockedOps(!lockOps),
      accessor: row => { return getTableButtonMenu(row) },
      align: 'center', width: '33px'
    });

    if (storeSlsLst.listType === 'r') {
      cols.push({
        id: "BTN_MAIL", 
        icon: lockSend ? <BiLockAlt style={{marginTop:'-1px'}} /> : <BiLockOpenAlt style={{marginTop:'-1px'}} />, 
        icon_alt: lockSend ? <BiLockOpenAlt style={{marginTop:'-1px'}} /> : <BiLockAlt style={{marginTop:'-1px'}} />, 
        iconTooltip: trans('field.column_lock_unlock'), 
        onIconClick: () => setLockSend(!lockSend),
        accessor: row => { 
          // Validación estricta por si el backend devuelve "   " o null
          const boHasEmail = row["txEmail"] && String(row["txEmail"]).trim() !== '';
          
          return <CxIconButtonNew 
            key={`mail_${row[storeSlsLst.table_idField]}`} // Fuerza el renderizado al cambiar de fila/página
            icon={boHasEmail ? <TbMailForward fontSize={24} /> : <TbMailOff fontSize={24} />} 
            style={{ margin: '0 0 0 0' }} 
            classType="ibs_iconbutton_table_body" 
            onClick={() => r_email_direct.current.sendSlsDoc(row, storeSlsLst.listType)} 
            disabled={lockSend}
            tooltip={trans('field.send_by_x', 'field.email')}
          />
        },
        align: 'center', width: '33px'
      });
    }

    if (size.isLarge) { // PANTALLA GRANDE
      cols.push({
        id: "BTN_PRT", 
        icon: <BiPrinter />,
        iconTooltip: trans('field.print'),
        accessor: row => { 
          return <CxIconButtonMenu data={row} onSelection={doPrintX} className="ibs_iconbutton_toolbar" icon={<RxDotFilled />}
              options={[
                { id: 'A4', text: trans('field.paper_a4'), },
                { id: 'A8', text: trans('field.paper_a8'), },
              ]}
            />
        },
        align: 'center', width: '33px'
      });
    }

    if (storeSlsLst.listType === 'q') {
      cols.push({ id: 'G', Header: "boAccepted", accessor: row => Boolean(row["boAccepted"] === '1'), show: false });
    }
    if (storeSlsLst.listType === 'i' || storeSlsLst.listType === 'r') {
      cols.push({ id: 'B', Header: "isVoid", accessor: row => Boolean(row["_isVoid"]), show: false });
    }
    if (storeSlsLst.listType === 'i') {
      cols.push({ id: 'G', Header: "hasReceipt", accessor: row => Boolean(row["_inReceipt"] !== ''), show: false });
    }
    if (storeSlsLst.listType === 'r') {
      if (isVerifactu) {
        cols.push({ id: 'A', Header: "VerifactuEnProceso", accessor: row => row["nuERecStatus"]==='1', show: false });
        cols.push({ id: 'W', Header: "VerifactuRechazada", accessor: row => row["nuERecStatus"]==='2', show: false });
        //cols.push({ id: 'G', Header: "VerifactuAceptada", accessor: row => row["nuERecStatus"]==='0', show: false });
      }
    }
    if (storeSlsLst.listType === 'i' || storeSlsLst.listType === 'r') {
      cols.push({ id: 'R', Header: "balance", accessor: row => Boolean((row["nuTotalPayment"] - row["nuTotalFinal"]) < 0 ? true : false), show: false });
    }
    return cols;
  }

  const getTableOptionalCols = () => {
    let cols = [];
    if ((isApp('vett') || isApp('spaw'))) {
    } else {
    }
    cols.push({ id: 'txBranchId', name: trans('field.branch_id') + " +🔍︎", checked: hasColumnBranchId() ? '1' : '0' });
    cols.push({ id: 'txTypeSeries', name: trans('field.series') + " +🔍︎", checked: hasColumnSeries() ? '1' : '0' });
    cols.push({ id: 'txReference', name: trans('field.reference') + " +🔍︎", checked: hasColumnReference() ? '1' : '0' });
    if (storeSlsLst.listType !== 'q') {
      cols.push({ id: 'txTypePayment', name: trans('field.type_payment'), checked: hasColumnTypePayment() ? '1' : '0' });
    }
    return cols;
  }

  const optionsSelected = (options) => {
    localStorage.setItem('MxSlsDocList.addcol_txBranchId', options.includes('txBranchId') ? '1' : '0');
    localStorage.setItem('MxSlsDocList.addcol_txTypeSeries', options.includes('txTypeSeries') ? '1' : '0');
    localStorage.setItem('MxSlsDocList.addcol_txReference', options.includes('txReference') ? '1' : '0');
    if (storeSlsLst.listType !== 'q') {
      localStorage.setItem('MxSlsDocList.addcol_txTypePayment', options.includes('txTypePayment') ? '1' : '0');
    }
    rf_table.current.setTooltipText(getTooltip());
    rf_table.current.clearSearch();
    forceUIUpdate();
  }

  const getTooltip = () => {
    let tip = '';
    if ((isApp('vett') || isApp('spaw')) && storeSlsLst.listType !== 'r') {
      tip = `${trans('field.doc')} / ${trans('field.date')} / ${trans('field.client')} / ${trans('field.patient')}`;
    } else {
      tip = `${trans('field.doc')} / ${trans('field.date')} / ${trans('field.client')}`;
    }
    if (hasColumnBranchId()) tip = tip + `${' / ' + trans('field.branch_id')}`;
    if (hasColumnSeries()) tip = tip + `${' / ' + trans('field.series')}`;
    if (hasColumnReference()) tip = tip + `${' / ' + trans('field.reference')}`;

    // 2025-06-03 - daq: no permito buscar por ésta porque utiliza group_concat
    //if (hasColumnTypePayment() && storeSlsLst.listType !== 'q') tip = tip + `${' / ' + trans('field.type_payment')}`;

    return tip;
  }

  return (
    <div>
      <CxToolbar
        moduleName={validListType ? `${trans('field.sales')}: ${docTitle}` : trans('field.sales')}
        //help="sales"
        background={storeSlsLst.listTypeBackground}
        addToolbarButtons={
          <>
            <div style={{ display: 'flex', flexDirection: 'row', marginRight: '0px', height: '28px' }}>
              {validListType && <GxIconButtonLastClient theTable={rf_table} />}

              <ToggleButtonGroup value={validListType} exclusive onChange={changeDocType} className={classes.toggleButtonGroup}>
                {true && (strAccessQ !== 'N') && (
                  <ToggleButton value="q">
                    <CxTooltip text={trans('field.quotations')} placement="right" arrow>
                      <span style={{ display: 'flex' }}>
                        <CxIcon 
                          backIcon={<DocType />} 
                          backColor="var(--ibs_color_toggle_yellow)" 
                          backSize="24px" 
                          frontIcon={<FaCircle />}
                          frontColor={FxStr.choose(strAccessQ, 'W|R|N', 'var(--ibs_color_green)', 'var(--ibs_color_yellow)', 'var(--ibs_color_red)')}
                          frontSize="9px"
                          frontShell="circle"
                          frontShellColor="white"
                          disableHover
                        />
                      </span>
                    </CxTooltip>
                  </ToggleButton>
                )}
                {useInvoices && (strAccessI !== 'N') && (
                  <ToggleButton value="i">
                    <CxTooltip text={trans('field.invoices')} placement="right" arrow>
                      <span style={{ display: 'flex' }}>
                        <CxIcon 
                          backIcon={<DocType />} 
                          backColor="var(--ibs_color_toggle_blue)" 
                          backSize="24px" 
                          frontIcon={<FaCircle />}
                          frontColor={FxStr.choose(strAccessI, 'W|R|N', 'var(--ibs_color_green)', 'var(--ibs_color_yellow)', 'var(--ibs_color_red)')}
                          frontSize="9px"
                          frontShell="circle"
                          frontShellColor="white"
                          disableHover
                        />
                      </span>
                    </CxTooltip>
                  </ToggleButton>
                )}
                {useReceipts && (strAccessR !== 'N') && (
                  <ToggleButton value="r">
                    <CxTooltip text={trans('field.receipts')} placement="right" arrow>
                      <span style={{ display: 'flex' }}>
                        <CxIcon 
                          backIcon={<DocType />} 
                          backColor="var(--ibs_color_toggle_green)" 
                          backSize="24px" 
                          frontIcon={<FaCircle />}
                          frontColor={FxStr.choose(strAccessR, 'W|R|N', 'var(--ibs_color_green)', 'var(--ibs_color_yellow)', 'var(--ibs_color_red)')}
                          frontSize="9px"
                          frontShell="circle"
                          frontShellColor="white"
                          disableHover
                        />
                      </span>
                    </CxTooltip>
                  </ToggleButton>
                )}
              </ToggleButtonGroup>

            </div>
          </>
        }
      />

      <div style={{ margin: 'var(--ibs_container_margin)' }}>
        {validListType && (
          <CxTable
            xref={rf_table}
            id={`MxSlsDocList-${validListType}`}
            tooltip={getTooltip()}
            url={`sls/doclist/${validListType}`}
            fullscreen
            showtip
            hasSearchBox
            hasButtonAdd={validListType !== 'r'}
            refColors={getRefColors()}
            disabledUntilUpgrade={Boolean(!FxEdition.isInEdition('SLS_unl') && storeCyStats.nuSalesThisMonth > 100)}
            onSpecialOptions={showSpecialOptions}
            onOpenForm={openForm}
            onReady={onReady}
            columns={getTableColumns()}
            optionalColumns={getTableOptionalCols()}
            optionalSorting={[
              { id: 'txBranchId', type: trans('field.branch_id') },
              { id: 'txTypeSeries asc, txXXX desc', type: `${trans('field.series')} + ${trans('field.doc')}` },
              { id: 'dtXXX asc', type: `${trans('field.date')} (${trans('field.order_asc')})` },
              { id: 'dtXXX desc', type: `${trans('field.date')} (${trans('field.order_desc')})` },
              { id: 'nuTotalFinal', type: trans('field.total') },
              { id: 'nuTotalPayment', type: trans('field.paid') },
            ]}
            optionalFromTo={true}
            optionalFromToButtonToday={true}
            optionalFromToButtonLast7Days={true}
            optionalFromToButtonLast30Days={true}
            onOptions={optionsSelected}
            speechExternal
          >
            <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
              {isVerifactu && <VerifactuSVG fill={'var(--ibs_color_blue)'} />}
            </div>          
          </CxTable>
        )}
      </div>

      <MxSlsDocListQuickPaymDlg xref={r_dlg_quick_paym} onOk={() => rf_table.current.redisplay()} />

      <CxDialog title={trans('msg.warning')} open={dlgAskSureToClone}
        onCancel={() => setDlgAskSureToClone(false)}
        onOk={() => { setDlgAskSureToClone(false); doClone() }}
        width="var(--ibs_control_width_md)"
        height='200px'>
        {trans('msg.ask_sure_to_x', 'field.clone')}
      </CxDialog>

      <CxDlgRadioList
        xref={r_dlg_special_options}
        onOk={doSpecialOption}
        width="var(--ibs_control_width_md)"
        onOpen={() => {
          const arrOptions = [];
          
          // Condicionamos la opción de eliminar para usuarios Master
          if (isMasterUser) {
            arrOptions.push({
              id: 'delete', 
              type: FxStr.choose(storeSlsLst.listType, 'q|i|r',
                trans('field.delete_listed_x_1', "field.quotations"),
                trans('field.delete_listed_x_1', "field.invoices"),
                trans('field.delete_listed_x_0', "field.receipts"),
              )
            });
          }

          // Añadimos la opción de renumerar (excepto para presupuestos 'q')
          const objRenum = FxStr.choose(storeSlsLst.listType, 'q|i|r',
            null,
            { id: 'renum', type: trans('field.renumber') },
            { id: 'renum', type: trans('field.renumber') },
          );

          if (objRenum) {
            arrOptions.push(objRenum);
          }

          return arrOptions;
        }}
        title={trans('field.special_options')}
      />

      <CxDialog
        xref={r_dlg_special_options_ask_from_n_series}
        title={trans('field.renumber')}
        open={dlgSpecialOptionsAskFromAndSeries}
        onOk={doSpecialOptionRenum}
        onCancel={() => setDlgSpecialOptionsAskFromAndSeries(false)}
        height='300px'>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }} >
          <CxDate xref={rf_special_options_from} label={trans('field.from')} today required />
          <CxChooser xref={rf_special_options_series} label={trans('field.series')} table="t_series" col_id="itSeries" col_tx="txTypeSeries" extra_filter_1={"boActive='1'"} />
        </div>

      </CxDialog>

      <CxSnackbar xref={r_snack_op_successful} severity="success" value={trans('msg.operation_successful')} />
      <CxSnackbar xref={r_snack_error} severity="error" />
      <CxSnackbar xref={r_snack_required} severity="error" />

      <GxPrint xref={r_print} />
      <GxEmail xref={r_email_direct} />

    </div>
  );

}

export default MxSlsDocList;